// extracted by mini-css-extract-plugin
module.exports = {"navbar":"styles_navbar__1C5-c","profile":"styles_profile__24Bn3"};